import requst from "./request";

export const userLogin = (data) => requst.post("/userLogin", data);
